export default __webpack_public_path__ + "static/media/w_overweight.62bf7ae3.svg";